import React, { useRef, useState, useEffect } from 'react';
import * as Yup from 'yup';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Form, Field, ErrorMessage } from 'formik';

import { APP_LABELS, FIELD_LENGTH } from '@config/app-config';
import Help from '@modules/shared/components/reusable-components/help';

import TextError from '@modules/shared/components/reusable-components/text-error';
import SuccessToaster from '@modules/shared/components/reusable-components/success-toaster';
import ErrorPopup from '@modules/employee-data-collection/components/upload-file/error-popup';
import PartialSaveWarningPopup from '@modules/shared/components/reusable-components/partial-save-popup';
import LastUpdateName from '@modules/annual-reports/components/anuual-reports-overview/last-update-name';

import {
  resetReduxState,
  postOvernightCampDataExpenses,
  getOvernightCampDataExpensesList
} from '@redux/overnight-camp-data-financials/action';
import { getCampReportsDashboardOverviewData } from '@redux/overnight-camp-data-overview/action';

import { AssociationAdminLoginDetailsSelector } from '@redux/login/selectors';
import { ApiParaSelector } from '@redux/overnight-camp-data-apiParameter/selectors';
import { YusaOvernightCampGetExpensesSelector } from '@redux/overnight-camp-data-financials/selectors';

import helpicon from '@static/images/caretdoubleright.svg';

const Expenses = props => {
  const formikref = useRef();
  const {
    status,
    setLoader,
    LoginUserData,
    getExpensesData,
    ApiParameterData,
    handleResetRedux,
    handleGetCampReportsDashboard,
    handlePostOvernightExpensesData,
    handleGetOvernightCampDataExpenses
  } = props;

  const role = get(LoginUserData, 'user.role[0]');

  const [help, setHelp] = useState(false);
  const [instructions, setInstructions] = useState('');
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successPopup, setSuccessPopup] = useState(false);

  const [resStatus, setResStatus] = useState();

  const initialValues = {
    totalOperatingExpenses: '',
    totalGrossNonOperatingExpenses: '',
    grandTotalExpenses: '',

    foodAndBeverage: '',
    thirdPartyFoodServicesStaff: '',
    insurance: '',
    programAndSupplies: '',
    campStoreMerchandise: '',
    marketingExpenses: '',
    property: '',
    wagesAndSalariesForSeasonalEmp: '',
    wagesAndSalariesForYearRoundEmp: '',
    benefitsForSeasonalEmp: '',
    benefitsForYearRoundEmp: '',
    taxesWagesAndSalariesForSeasonalEmp: '',
    taxesWagesAndSalariesForYearRoundEmp: '',
    taxes: '',
    transportation: '',
    utilities: '',
    total: ''
  };

  const editValues = {
    totalOperatingExpenses: getExpensesData?.data?.TotalOperatingExpenses,
    totalGrossNonOperatingExpenses:
      getExpensesData?.data?.TotalGrossNonOperatingExpenses,

    foodAndBeverage: getExpensesData?.data?.FoodAndBeverage,
    thirdPartyFoodServicesStaff:
      getExpensesData?.data?.ThirdPartyFoodServicesStaff,
    insurance: getExpensesData?.data?.Insurance,
    programAndSupplies: getExpensesData?.data?.ProgramAndSupplies,
    campStoreMerchandise: getExpensesData?.data?.CampStoreMerchandise,
    marketingExpenses: getExpensesData?.data?.MarketingExpenses,
    property: getExpensesData?.data?.Property,
    wagesAndSalariesForSeasonalEmp:
      getExpensesData?.data?.WegesAndSalariesForSeasonalEmp,
    wagesAndSalariesForYearRoundEmp:
      getExpensesData?.data?.WegesAndSalariesForYearRoundEmp,
    benefitsForSeasonalEmp: getExpensesData?.data?.BenefitsForSeasonalEmp,
    benefitsForYearRoundEmp: getExpensesData?.data?.BenefitsForYearRoundEmp,
    taxesWagesAndSalariesForSeasonalEmp:
      getExpensesData?.data?.TaxesWegesAndSalariesForSeasonalEmp,
    taxesWagesAndSalariesForYearRoundEmp:
      getExpensesData?.data?.TaxesWegesAndSalariesForYearRoundEmp,
    taxes: getExpensesData?.data?.Taxes,
    transportation: getExpensesData?.data?.Transportation,
    utilities: getExpensesData?.data?.Utilities
  };

  const validationSchema = Yup.object({
    totalOperatingExpenses: Yup.string().nullable(),
    totalGrossNonOperatingExpenses: Yup.string().nullable(),
    grandTotalExpenses: Yup.string().nullable(),

    foodAndBeverage: Yup.string().nullable(),
    thirdPartyFoodServicesStaff: Yup.string().nullable(),
    insurance: Yup.string().nullable(),
    programAndSupplies: Yup.string().nullable(),
    campStoreMerchandise: Yup.string().nullable(),
    marketingExpenses: Yup.string().nullable(),
    property: Yup.string().nullable(),
    wagesAndSalariesForSeasonalEmp: Yup.string().nullable(),
    wagesAndSalariesForYearRoundEmp: Yup.string().nullable(),
    benefitsForSeasonalEmp: Yup.string().nullable(),
    benefitsForYearRoundEmp: Yup.string().nullable(),
    taxesWagesAndSalariesForSeasonalEmp: Yup.string().nullable(),
    taxesWagesAndSalariesForYearRoundEmp: Yup.string().nullable(),
    taxes: Yup.string().nullable(),
    transportation: Yup.string().nullable(),
    utilities: Yup.string().nullable(),
    total: Yup.string().nullable()
  });

  const handleGetCall = success => {
    setLoader(true);
    handleGetOvernightCampDataExpenses(
      ApiParameterData?.branchNumber,
      ApiParameterData?.reportBatchId,
      ApiParameterData?.year
    ).then(res => {
      if (res && res.status === 200) {
        setLoader(false);
        if (success) {
          setSuccessPopup(true);
        }
      } else {
        setLoader(false);
        setErrorMessage(APP_LABELS.COMMON_ERROR_MESSAGE);
        setErrorPopup(true);
      }
    });
  };

  useEffect(() => {
    handleGetCall();
    setInstructions(
      JSON.parse(sessionStorage.getItem('allinstructions'))['expenses']
        ?.Instruction
    );
    return () => {
      handleResetRedux('YusaOvernightCampGetExpensesList');
    };
  }, []);

  const handleShowHelp = () => {
    setHelp(true);
  };
  const hideShowHelp = () => {
    setHelp(false);
  };

  const getClassNames = (errorsValue, touchedValue, checkboxValue) => {
    let className = 'ymca-field';

    if (errorsValue && touchedValue) {
      className = 'ymca-field invalid';
    } else if (checkboxValue) {
      className = 'ymca-field ymca-fieldDisabled';
    }
    return className;
  };

  const handleChange = (e, setFieldValue, name) => {
    const result = e.target.value.replace(/\D+/g, '');
    setFieldValue(name, result);
  };

  const convertedValue = value => (value === 0 || value ? Number(value) : null);

  const onSubmit = values => {
    setLoader(true);

    const payloadBody = {
      data: {
        CampExpensesId:
          getExpensesData?.data?.CampExpensesId === undefined
            ? 0
            : getExpensesData.data.CampExpensesId,

        Year: ApiParameterData?.year,
        BranchNumber: ApiParameterData?.branchNumber,
        ReportBatchId: ApiParameterData?.reportBatchId,

        TotalOperatingExpenses: convertedValue(values?.totalOperatingExpenses),
        TotalGrossNonOperatingExpenses: convertedValue(
          values?.totalGrossNonOperatingExpenses
        ),

        FoodAndBeverage: convertedValue(values?.foodAndBeverage),

        ThirdPartyFoodServicesStaff: convertedValue(
          values?.thirdPartyFoodServicesStaff
        ),

        Insurance: convertedValue(values?.insurance),

        ProgramAndSupplies: convertedValue(values?.programAndSupplies),

        CampStoreMerchandise: convertedValue(values?.campStoreMerchandise),

        MarketingExpenses: convertedValue(values?.marketingExpenses),

        Property: convertedValue(values?.property),

        WegesAndSalariesForSeasonalEmp: convertedValue(
          values?.wagesAndSalariesForSeasonalEmp
        ),
        WegesAndSalariesForYearRoundEmp: convertedValue(
          values?.wagesAndSalariesForYearRoundEmp
        ),

        BenefitsForSeasonalEmp: convertedValue(values?.benefitsForSeasonalEmp),
        BenefitsForYearRoundEmp: convertedValue(
          values?.benefitsForYearRoundEmp
        ),

        TaxesWegesAndSalariesForSeasonalEmp: convertedValue(
          values?.taxesWagesAndSalariesForSeasonalEmp
        ),
        TaxesWegesAndSalariesForYearRoundEmp: convertedValue(
          values?.taxesWagesAndSalariesForYearRoundEmp
        ),

        Taxes: convertedValue(values?.taxes),
        Transportation: convertedValue(values?.transportation),
        Utilities: convertedValue(values?.utilities),

        RecordStatus: getExpensesData?.data?.RecordStatus || '',

        CreatedByPersonId: LoginUserData?.user?.personBranchId,
        UpdatedByPersonId: LoginUserData?.user?.personBranchId,
        Total: calculateTotal(
          values.foodAndBeverage,
          values.thirdPartyFoodServicesStaff,
          values.insurance,
          values.programAndSupplies,
          values.campStoreMerchandise,
          values.MarketingExpenses,
          values.property,
          values.wagesAndSalariesForSeasonalEmp,
          values.wagesAndSalariesForYearRoundEmp,
          values.benefitsForSeasonalEmp,
          values.benefitsForYearRoundEmp,
          values.taxesWagesAndSalariesForSeasonalEmp,
          values.taxesWagesAndSalariesForYearRoundEmp,
          values.taxes,
          values.transportation,
          values.utilities
        )
      },
      isSuccess: true
    };

    setSuccessPopup(false);

    handlePostOvernightExpensesData(payloadBody).then(res => {
      if (res.status === 201 && res?.data?.isSuccess) {
        setResStatus(res.data?.RecordStatus);
        handleGetCall(true);
        handleGetCampReportsDashboard(
          ApiParameterData?.branchNumber,
          ApiParameterData?.year
        );
      } else if (res.statusCode === 409) {
        setLoader(false);
        setErrorMessage(res.errorMessage);
        setErrorPopup(true);
      } else {
        setLoader(false);
        setErrorPopup(true);
      }
    });
  };

  const calculateTotal = (
    number1 = 0,
    number2 = 0,
    number3 = 0,
    number4 = 0,
    number5 = 0,
    number6 = 0,
    number7 = 0,
    number8 = 0,
    number9 = 0,
    number10 = 0,
    number11 = 0,
    number12 = 0,
    number13 = 0,
    number14 = 0,
    number15 = 0,
    number16 = 0
  ) =>
    Number(number1) +
    Number(number2) +
    Number(number3) +
    Number(number4) +
    Number(number5) +
    Number(number6) +
    Number(number7) +
    Number(number8) +
    Number(number9) +
    Number(number10) +
    Number(number11) +
    Number(number12) +
    Number(number13) +
    Number(number14) +
    Number(number15) +
    Number(number16);

  return (
    <>
      <button
        type="button"
        className="ymca-help-link text-decoration-none ymca-up-data-help-link annual-report-help"
        onClick={handleShowHelp}
      >
        <span>HELP</span>
        <img src={helpicon} className="img-fluid" alt="caret-icon" />
      </button>

      <div className="ymca-program mb-2">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-2 pb-3">
          <div className="ymca-instructionBoxes">
            <h4 className="ymca-instructHeadline">{APP_LABELS.INSTRUCTIONS}</h4>
            <p className="ymca-instructTitle">
              <div
                dangerouslySetInnerHTML={{
                  __html: instructions
                }}
              />
            </p>
          </div>
        </div>
        {getExpensesData?.data?.RecordStatus === 'Partial' && (
          <PartialSaveWarningPopup />
        )}
        <Formik
          innerRef={formikref}
          initialValues={editValues || initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {({ values, setFieldValue, errors, touched, dirty }) => {
            sessionStorage.setItem('dirty', dirty);
            return (
              <Form autoComplete="off">
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div className="ymca-selectWrap">
                    <div className="ymca-programActivities txt-mandatory">
                      What was your Overnight Summer Camps expenses for this
                      past summer? Do not include those from other programs or
                      services offered such as Day Camp, Retreats, Conferences,
                      etc.
                    </div>
                  </div>
                </div>
                <div className="ymca-tableResponsive">
                  <table className="table ymca-table table-striped ymca-autoLength">
                    <thead>
                      <tr className="ymca-cuttingData">
                        <th>&nbsp;</th>
                        <th>$</th>
                        <th className="ymca-defaultSpace">&nbsp;</th>
                        <th className="ymca-defaultSpace">&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody className="ymca-cuttingBody ymca-lengths">
                      <tr>
                        <td>
                          <div className="txt-mandatory">
                            Total Operating Expenses
                          </div>
                          <div className="ymca-lighter-gray-text ms-4">
                            <ul>
                              <li>
                                Include all overhead, salaries, benefits,
                                insurance, maintenance, and other operational
                                expenses.
                              </li>
                              <li>
                                Include association administrative fees
                                (sometimes called association support or
                                metro-chargeback).
                              </li>
                              <li>
                                Do not include depreciation, interest or any
                                subsidy from one branch to another, whether the
                                branch is giving or receiving the subsidy.
                              </li>
                              <li>
                                Do not include any board mandated reserves or
                                other non-GAAP charges.
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="totalOperatingExpenses"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.totalOperatingExpenses,
                              touched.totalOperatingExpenses
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'totalOperatingExpenses'
                              )
                            }
                            value={values.totalOperatingExpenses}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="totalOperatingExpenses"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td>
                          <div className="txt-mandatory">
                            Total Gross Non-operating Expenses
                          </div>
                          <div className="ymca-lighter-gray-text ms-4">
                            <ul>
                              <li>
                                Include any expenses not accounted for in
                                operating expenses such as depreciation,
                                interest, and capital expenses.
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="totalGrossNonOperatingExpenses"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.totalGrossNonOperatingExpenses,
                              touched.totalGrossNonOperatingExpenses
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'totalGrossNonOperatingExpenses'
                              )
                            }
                            value={values.totalGrossNonOperatingExpenses}
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="">Grand Total Expenses</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="grandTotalExpenses"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className="ymca-field ymca-fieldDisabled"
                            value={calculateTotal(
                              values?.totalOperatingExpenses,
                              values?.totalGrossNonOperatingExpenses
                            )}
                            disabled
                          />
                          <ErrorMessage
                            component={TextError}
                            name="grandTotalExpenses"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div className="ymca-selectWrap">
                    <div className="ymca-programActivities txt-mandatory">
                      Please provide the following detail on your Overnight
                      Camp's Expenses. Do not include those from other programs
                      or services offered such as Day Camp, Retreats,
                      Conferences, etc. If none, enter '0'.
                      {/* The total reported
                      here should match the total revenue reported in the
                      previous question */}
                    </div>
                  </div>
                </div>

                <div className="ymca-tableResponsive">
                  <table className="table ymca-table table-striped ymca-autoLength">
                    <thead>
                      <tr className="ymca-cuttingData">
                        <th>&nbsp;</th>
                        <th>$</th>
                        <th className="ymca-defaultSpace">&nbsp;</th>
                        <th className="ymca-defaultSpace">&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody className="ymca-cuttingBody ymca-lengths">
                      <tr>
                        <td>
                          <div className="txt-mandatory">
                            Food and Beverage (Product Cost)
                          </div>
                          <div className="ymca-lighter-gray-text ms-4">
                            <ul>
                              <li>
                                Exclude labor related expenses or contract
                                services associated with food provision or
                                foodservice management.
                              </li>
                              <li>
                                Exclude costs for food/snacks/drinks for resale
                                in the camp store.
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="foodAndBeverage"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.foodAndBeverage,
                              touched.foodAndBeverage
                            )}
                            onChange={e =>
                              handleChange(e, setFieldValue, 'foodAndBeverage')
                            }
                            value={values.foodAndBeverage}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="foodAndBeverage"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td>
                          <div className="txt-mandatory">
                            Third-party food services staff, labor and
                            management fees (if any)
                          </div>
                          <div className="ymca-lighter-gray-text ms-4">
                            <ul>
                              <li>
                                Include salaried food services staff in salaries
                                lines below.
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="thirdPartyFoodServicesStaff"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.thirdPartyFoodServicesStaff,
                              touched.thirdPartyFoodServicesStaff
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'thirdPartyFoodServicesStaff'
                              )
                            }
                            value={values.thirdPartyFoodServicesStaff}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="thirdPartyFoodServicesStaff"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          Insurance (Auto, Liability, Property, Worker's Comp,
                          etc.) *
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="insurance"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.insurance,
                              touched.insurance
                            )}
                            onChange={e =>
                              handleChange(e, setFieldValue, 'insurance')
                            }
                            value={values.insurance}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="insurance"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">Program and Supplies</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="programAndSupplies"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.programAndSupplies,
                              touched.programAndSupplies
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'programAndSupplies'
                              )
                            }
                            value={values.programAndSupplies}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="programAndSupplies"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          Camp store merchandise purchased for resale
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="campStoreMerchandise"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.campStoreMerchandise,
                              touched.campStoreMerchandise
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'campStoreMerchandise'
                              )
                            }
                            value={values.campStoreMerchandise}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="campStoreMerchandise"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          Marketing expenses (Online, Print, Digital Media, and
                          Promotions, etc.)
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="marketingExpenses"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.marketingExpenses,
                              touched.marketingExpenses
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'marketingExpenses'
                              )
                            }
                            value={values.marketingExpenses}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="marketingExpenses"
                          />
                        </td>

                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          Property (Lease/Mortgage)
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="property"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.property,
                              touched.property
                            )}
                            onChange={e =>
                              handleChange(e, setFieldValue, 'property')
                            }
                            value={values.property}
                          />
                          <ErrorMessage component={TextError} name="property" />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td>
                          <div className="txt-mandatory">
                            Wages and Salaries for seasonal employees (both full
                            and part-time)
                          </div>

                          <div className="ymca-lighter-gray-text ms-4">
                            <ul>
                              <li>
                                Include any stipends paid to international
                                staff, international staffing agency fees and
                                any visa fees related to employing international
                                staff.
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="wagesAndSalariesForSeasonalEmp"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.wagesAndSalariesForSeasonalEmp,
                              touched.wagesAndSalariesForSeasonalEmp
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'wagesAndSalariesForSeasonalEmp'
                              )
                            }
                            value={values.wagesAndSalariesForSeasonalEmp}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="wagesAndSalariesForSeasonalEmp"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td>
                          <div className="txt-mandatory">
                            Wages and Salaries for year-round employees (both
                            full and part-time)
                          </div>
                          <div className="ymca-lighter-gray-text ms-4">
                            <ul>
                              <li>
                                Include any stipends paid to international
                                staff, international staffing agency fees and
                                any visa fees related to employing international
                                staff.
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="wagesAndSalariesForYearRoundEmp"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.wagesAndSalariesForYearRoundEmp,
                              touched.wagesAndSalariesForYearRoundEmp
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'wagesAndSalariesForYearRoundEmp'
                              )
                            }
                            value={values.wagesAndSalariesForYearRoundEmp}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="wagesAndSalariesForYearRoundEmp"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td>
                          <div className="txt-mandatory">
                            Benefits for seasonal employees (both full and
                            part-time)
                          </div>
                          <div className="ymca-lighter-gray-text ms-4">
                            <ul>
                              <li>
                                Include all seasonal employee benefit expenses
                                including but not limited to health, dental and
                                life insurance and retirement contributions made
                                on an employee's behalf, as applicable.
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="benefitsForSeasonalEmp"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.benefitsForSeasonalEmp,
                              touched.benefitsForSeasonalEmp
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'benefitsForSeasonalEmp'
                              )
                            }
                            value={values.benefitsForSeasonalEmp}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="benefitsForSeasonalEmp"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td>
                          <div className="txt-mandatory">
                            Benefits for year-round employees (both full and
                            part-time)
                          </div>
                          <div className="ymca-lighter-gray-text ms-4">
                            <ul>
                              <li>
                                Include all year-round employee benefit expenses
                                including but not limited to health, dental and
                                life insurance and retirement contributions made
                                on an employee's behalf, as applicable.
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="benefitsForYearRoundEmp"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.benefitsForYearRoundEmp,
                              touched.benefitsForYearRoundEmp
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'benefitsForYearRoundEmp'
                              )
                            }
                            value={values.benefitsForYearRoundEmp}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="benefitsForYearRoundEmp"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          Taxes on wages and salaries for seasonal employees
                          (both full and part-time)
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="taxesWagesAndSalariesForSeasonalEmp"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.taxesWagesAndSalariesForSeasonalEmp,
                              touched.taxesWagesAndSalariesForSeasonalEmp
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'taxesWagesAndSalariesForSeasonalEmp'
                              )
                            }
                            value={values.taxesWagesAndSalariesForSeasonalEmp}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="taxesWagesAndSalariesForSeasonalEmp"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          Taxes on wages and salaries for year-round employees
                          (both full and part-time)
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="taxesWagesAndSalariesForYearRoundEmp"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.taxesWegesAndSalariesForYearRoundEmp,
                              touched.taxesWegesAndSalariesForYearRoundEmp
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'taxesWagesAndSalariesForYearRoundEmp'
                              )
                            }
                            value={values.taxesWagesAndSalariesForYearRoundEmp}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="taxesWagesAndSalariesForYearRoundEmp"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          Taxes (Sales/Property)
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="taxes"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.taxes,
                              touched.taxes
                            )}
                            onChange={e =>
                              handleChange(e, setFieldValue, 'taxes')
                            }
                            value={values.taxes}
                          />
                          <ErrorMessage component={TextError} name="taxes" />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          Transportation (Lease, Buses, etc.)
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="transportation"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.transportation,
                              touched.transportation
                            )}
                            onChange={e =>
                              handleChange(e, setFieldValue, 'transportation')
                            }
                            value={values.transportation}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="transportation"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          Utilities (Electricity, Propane/Gas/Diesel,
                          Waste/Trash Removal)
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="utilities"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.utilities,
                              touched.utilities
                            )}
                            onChange={e =>
                              handleChange(e, setFieldValue, 'utilities')
                            }
                            value={values.utilities}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="utilities"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="">Total</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="total"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className="ymca-field ymca-fieldDisabled"
                            value={calculateTotal(
                              values?.foodAndBeverage,
                              values?.thirdPartyFoodServicesStaff,
                              values?.insurance,
                              values?.programAndSupplies,
                              values?.campStoreMerchandise,
                              values?.marketingExpenses,
                              values?.property,
                              values?.wagesAndSalariesForSeasonalEmp,
                              values?.wagesAndSalariesForYearRoundEmp,
                              values?.benefitsForSeasonalEmp,
                              values?.benefitsForYearRoundEmp,
                              values?.taxesWagesAndSalariesForSeasonalEmp,
                              values?.taxesWagesAndSalariesForYearRoundEmp,
                              values?.taxes,
                              values?.transportation,
                              values?.utilities
                            )}
                            disabled
                          />
                          <ErrorMessage component={TextError} name="total" />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="ymca-submitHighlighter">
                  <LastUpdateName
                    Username={getExpensesData?.data?.UpdatedbyName}
                    Time={getExpensesData?.data?.UpdatedDateTime}
                  />
                </div>
                {role !== APP_LABELS.YUSA_DATA_VIEWER && (
                  <button
                    type="submit"
                    className="btn ymca-savingBTN ymca-btnRightUntitled float-end mt-5"
                    disabled={
                      status?.toUpperCase() === APP_LABELS.STATUS_SUBMITTED
                    }
                  >
                    Save
                  </button>
                )}
              </Form>
            );
          }}
        </Formik>
      </div>
      {successPopup && <SuccessToaster Status={resStatus} />}

      <ErrorPopup
        handleCloseErrorPopup={() => {
          setErrorPopup(false);
        }}
        errorMessage={errorMessage}
        showErrorPopup={errorPopup}
      />
      {help && <Help hidePopup={hideShowHelp} keyValue="expenses" />}
    </>
  );
};

Expenses.propTypes = {
  setLoader: PropTypes.func.isRequired,
  handleResetRedux: PropTypes.func.isRequired,
  handleGetCampReportsDashboard: PropTypes.func.isRequired,
  handlePostOvernightExpensesData: PropTypes.func.isRequired,
  handleGetOvernightCampDataExpenses: PropTypes.func.isRequired,

  status: PropTypes.objectOf(PropTypes.any).isRequired,
  LoginUserData: PropTypes.objectOf(PropTypes.any).isRequired,
  getExpensesData: PropTypes.objectOf(PropTypes.any).isRequired,
  ApiParameterData: PropTypes.objectOf(PropTypes.any).isRequired
};

const mapDispatchToProps = {
  handleResetRedux: resetReduxState,
  handlePostOvernightExpensesData: postOvernightCampDataExpenses,
  handleGetCampReportsDashboard: getCampReportsDashboardOverviewData,
  handleGetOvernightCampDataExpenses: getOvernightCampDataExpensesList
};

const mapStateToProps = state => ({
  ApiParameterData: ApiParaSelector(state),
  getExpensesData: YusaOvernightCampGetExpensesSelector(state),
  LoginUserData: AssociationAdminLoginDetailsSelector(state)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(Expenses));
